module.exports = __webpack_public_path__ + "img/1440.b679f8c4.jpg";